export const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber || phoneNumber === "Unknown")
        return phoneNumber;
    const digits = phoneNumber.replace(/\D/g, "");
    if (digits.length === 10) {
        return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    }
    return phoneNumber;
};
export const formatPhoneNumberForListing = (phoneNumber) => {
    if (!phoneNumber)
        return "Unknown";
    const cleaned = phoneNumber.replace(/\D/g, "");
    if (cleaned.length === 10) {
        return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    }
    return phoneNumber;
};
//# sourceMappingURL=phoneUtils.js.map